import React, { ComponentType, ReactElement, ReactNode } from 'react';
import { ContentState } from 'draft-js';
import { MentionData } from './mentionsPlugin';

export interface SubMentionComponentProps {
  mention: MentionData;
  children: ReactNode;
  className: string;
  entityKey: string;
  decoratedText: string;
}

export interface MentionProps {
  mention: MentionData;
  children: ReactNode;
  className: string;
  entityKey: string;
  mentionComponent?: ComponentType<SubMentionComponentProps>;
  decoratedText: string;
  contentState: ContentState;
}

function MentionLink({ mention, children, className }: SubMentionComponentProps): ReactElement {
  return (
    <a href={mention.link} className={className} spellCheck={false} data-testid="mentionLink">
      {children}
    </a>
  );
}

function MentionText({ children, className }: SubMentionComponentProps): ReactElement {
  return (
    <span className={className} spellCheck={false} data-testid="mentionText">
      {children}
    </span>
  );
}

export default function Mention(props: MentionProps): ReactElement {
  const { entityKey, mentionComponent, children, decoratedText, contentState } = props;

  const combinedClassName = 'mention';
  const mention = contentState.getEntity(entityKey).getData().mention;
  const Component = mentionComponent || (mention?.link ? MentionLink : MentionText);
  return (
    <Component entityKey={entityKey} mention={mention} className={combinedClassName} decoratedText={decoratedText}>
      {children}
    </Component>
  );
}
